// extracted by mini-css-extract-plugin
module.exports = {"root":"Dots_root__kzBuu","dot":"Dots_dot__12hsj","dotActive":"Dots_dotActive__giTSq"};